// import { lazy, Suspense } from 'react';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import AuthProtected from './AuthProtected';
// import AdminProtected from './AdminProtected';
// const Login = lazy(() => import('../pages/auth/Login'));
// const ForgotPassword = lazy(() => import('../pages/auth/ForgotPassword'));
// const VerifyEmail = lazy(() => import('../pages/auth/VerifyEmail'));
// const ResetPassword = lazy(() => import('../pages/auth/ResetPassword'));
// const Dashboard = lazy(() => import('../pages/admin/Dashboard'));
// const Clients = lazy(() => import('../pages/admin/Clients'));
// const Reviews = lazy(() => import('../pages/admin/Reviews'));
// const SupportTickets = lazy(() => import('../pages/admin/SupportTickets'));
// const Notifications = lazy(() => import('../pages/admin/Notifications'));
// const SearchList = lazy(() => import('../pages/admin/SearchList'));
// const ServiceProviders = lazy(() => import('../pages/admin/serviceProvider/ServiceProviders'));
// const ServiceProviderDetails = lazy(() => import('../pages/admin/serviceProvider/ServiceProviderDetails'));

// const Routing = () => {
//     return (
//         <Router>
//             <Routes>
//                 <Route path='/' element={<AuthProtected />}>
//                     <Route path='/login' element={<Suspense fallback='Loading...'><Login /></Suspense>} />
//                     <Route path='/forgot-password' element={<Suspense fallback='Loading...'><ForgotPassword /></Suspense>} />
//                     <Route path='/verify' element={<Suspense fallback='Loading...'><VerifyEmail /></Suspense>} />
//                     <Route path='/reset-password' element={<Suspense fallback='Loading...'><ResetPassword /></Suspense>} />
//                 </Route>
//                 <Route path='/' element={<AdminProtected />} >
//                     <Route path='/dashboard' element={<Suspense fallback='Loading...'><Dashboard /></Suspense>} />
//                     <Route path='/clients' element={<Suspense fallback='Loading...'><Clients /></Suspense>} />
//                     <Route path='/service-providers' element={<Suspense fallback='Loading...'><ServiceProviders /></Suspense>} />
//                     <Route path='/service-providers/:id' element={<Suspense fallback='Loading...'><ServiceProviderDetails /></Suspense>} />
//                     <Route path='/reviews' element={<Suspense fallback='Loading...'><Reviews /></Suspense>} />
//                     <Route path='/support-tickets' element={<Suspense fallback='Loading...'><SupportTickets /></Suspense>} />
//                     <Route path='/notifications' element={<Suspense fallback='Loading...'><Notifications /></Suspense>} />
//                     <Route path='/search-list' element={<Suspense fallback='Loading...'><SearchList /></Suspense>} />
//                 </Route>
//                 <Route path='*' element={<h1>Page Not Found</h1>} />
//             </Routes>
//         </Router>
//     )
// };

// export default Routing;




import { BrowserRouter as Router, Routes, Route, useNavigate } from 'react-router-dom';
import AuthProtected from './AuthProtected';
import AdminProtected from './AdminProtected';
import Login from '../pages/auth/Login';
import ForgotPassword from '../pages/auth/ForgotPassword';
import VerifyEmail from '../pages/auth/VerifyEmail';
import ResetPassword from '../pages/auth/ResetPassword';
import Dashboard from '../pages/admin/Dashboard';
import Clients from '../pages/admin/Clients';
import ServiceProviders from '../pages/admin/serviceProvider/ServiceProviders';
import ServiceProviderDetails from '../pages/admin/serviceProvider/ServiceProviderDetails';
import Reviews from '../pages/admin/Reviews';
import SupportTickets from '../pages/admin/SupportTickets';
import SearchList from '../pages/admin/SearchList';
import Notifications from '../pages/admin/Notifications';
import { useEffect, useState } from 'react';
import { getFromLocalStorage } from '../utils/storageUtil';
import VerifyEmailGuard from './guards/VerifyEmailGuard';
import ResetPassGuard from './guards/ResetPassGuard';
import PageNotFound from '../pages/auth/PageNotFound';
import PrototypePreview from '../pages/admin/PrototypePreview';
import StagingOverview from '../pages/admin/StagingOverview';
import StagingProviders from '../pages/admin/StagingProviders';
import StagingWorkspace from '../pages/admin/StagingWorkspace';
import NewWorkspace from '../pages/admin/NewWorkspace';
import { GetCurrentUser } from '../utils/api';


const Root = () => {
    const [user, setUser] = useState(null)
    const navigate = useNavigate();
    const admin = getFromLocalStorage('admin');
    (async () => {
        const { data } = await GetCurrentUser(admin?.id);
        setUser(data);
    })();

    useEffect(() => {
        if (user) {
            navigate('/admin/dashboard');
        } else {
            navigate('/auth/login');
        }
    }, [navigate, user]);
    return null;
};


const Routing = () => {

    return (
        <Router>
            <Routes>
                <Route path='/' element={<Root />} />
                <Route path='/auth' element={<AuthProtected />}>
                    <Route path='login' element={<Login />} />
                    <Route path='forgot-password' element={<ForgotPassword />} />
                    <Route path='verify' element={<VerifyEmailGuard><VerifyEmail /></VerifyEmailGuard>} />
                    <Route path='reset-password' element={<ResetPassGuard><ResetPassword /></ResetPassGuard>} />
                </Route>
                <Route path='/admin' element={<AdminProtected />} >
                    <Route path='dashboard' element={<Dashboard />} />
                    <Route path='prototype-preview' element={<PrototypePreview />} />
                    <Route path='staging-overview' element={<StagingOverview />} />
                    <Route path='staging-providers' element={<StagingProviders />} />
                    <Route path='staging-workspace' element={<StagingWorkspace />} />
                    <Route path='workspace-notifications' element={<NewWorkspace page='notifications' />} />
                    <Route path='workspace-settings' element={<NewWorkspace page='settings' />} />
                    <Route path='clients' element={<Clients />} />
                    <Route path='service-providers' element={<ServiceProviders />} />
                    <Route path='service-providers/:id' element={<ServiceProviderDetails />} />
                    <Route path='reviews' element={<Reviews />} />
                    <Route path='support-tickets' element={<SupportTickets />} />
                    <Route path='notifications' element={<Notifications />} />
                    <Route path='search-list' element={<SearchList />} />
                </Route>
                <Route path='*' element={<PageNotFound />} />
            </Routes>
        </Router>
    )
};

export default Routing;